import { useRouter } from 'next/router';
import { IPaymentOption } from '../../../../../types/@types/generated/contentful';
import { ImpacterResponse } from '../../../../../types/ImpacterTypes';
import { GetCategoryResponse } from '../../../../../utils/api';
import useLocale from '../../../../../utils/hooks/useLocale';
import KlarnaPaymentCheckoutWithSelector from '../../../payment/klarna/KlarnaPaymentCheckoutWithSelector';

function KlarnaOneTimeWidget({
  impacters,
  category,
  initiator,
  paymentOption,
  campaign,
  thankYouPageSlugOverride,
}: {
  impacters?: Pick<ImpacterResponse, 'id' | 'externalId' | 'nickname'>[];
  category?: GetCategoryResponse;
  initiator: string;
  paymentOption?: IPaymentOption;
  campaign?: string;
  thankYouPageSlugOverride?: string;
}) {
  const router = useRouter();
  const locale = useLocale();
  const country = (router.query.country as string) || getDefaultCountry(router.locale);

  const onSuccess = ({
    paymentRequestId,
    subscriptionId,
  }: {
    paymentRequestId?: string;
    subscriptionId?: string;
  }) => {
    const id = subscriptionId || paymentRequestId;
    const type = subscriptionId ? 'subscription' : 'one-off';

    if (thankYouPageSlugOverride) {
      router.push(
        `/thank-you?type=${type}&id=${id}&slug=${thankYouPageSlugOverride}`,
        `/thank-you?type=${type}&id=${id}&slug=${thankYouPageSlugOverride}`,
        { locale },
      );
    } else {
      router.push(`/thank-you?type=${type}&id=${id}`, `/thank-you?type=${type}&id=${id}`, {
        locale,
      });
    }
  };

  return (
    <KlarnaPaymentCheckoutWithSelector
      country={country}
      language={locale}
      impacters={impacters}
      category={category}
      onSuccess={onSuccess}
      initiator={initiator}
      paymentOption={paymentOption}
      variant="with-borders"
      campaign={campaign}
    />
  );
}

const getDefaultCountry = (currentLanguage?: string) => {
  switch (currentLanguage) {
    case 'sv':
      return 'SE';
    case 'de':
      return 'DE';
    default:
      return 'SE';
  }
};

export default KlarnaOneTimeWidget;
